module.exports = __webpack_public_path__ + "img/doradzamyauta.704765f3.png";